/**
 * Cookie Consent Management (JavaScript)
 * Mirrors the TS reference API: hasConsent, setConsent, needsConsent, getConsentInfo, clearConsent
 */

const CONSENT_KEY = 'cookieConsent';
const CONSENT_VERSION = 2; // Increment if policy changes

export function hasConsent() {
  if (typeof window === 'undefined') return false;
  try {
    const consent = localStorage.getItem(CONSENT_KEY);
    if (!consent) return false;
    const parsed = JSON.parse(consent);
    // Handle backward compatibility with version 1
    if (parsed.version === 1) {
      return parsed.functional === true;
    }
    if (parsed.version !== CONSENT_VERSION) return false;
    return parsed.functional === true;
  } catch (e) {
    return false;
  }
}

export function hasMarketingConsent() {
  if (typeof window === 'undefined') return false;
  try {
    const consent = localStorage.getItem(CONSENT_KEY);
    if (!consent) return false;
    const parsed = JSON.parse(consent);
    // Version 1 didn't have marketing consent, so return false
    if (parsed.version === 1) return false;
    if (parsed.version !== CONSENT_VERSION) return false;
    return parsed.marketing === true;
  } catch (e) {
    return false;
  }
}

export function setConsent(options = {}) {
  if (typeof window === 'undefined') return;
  try {
    const consent = {
      functional: true,
      marketing: options.marketing === true,
      timestamp: Date.now(),
      version: CONSENT_VERSION
    };
    localStorage.setItem(CONSENT_KEY, JSON.stringify(consent));
  } catch (error) {
    // eslint-disable-next-line no-console
    console.warn('Failed to save cookie consent:', error);
  }
}

export function setMarketingConsent(marketing) {
  if (typeof window === 'undefined') return;
  try {
    const existingConsent = getConsentInfo();
    const consent = {
      functional: existingConsent?.functional === true || false,
      marketing: marketing === true,
      timestamp: Date.now(),
      version: CONSENT_VERSION
    };
    localStorage.setItem(CONSENT_KEY, JSON.stringify(consent));
  } catch (error) {
    // eslint-disable-next-line no-console
    console.warn('Failed to save marketing consent:', error);
  }
}

export function needsConsent() {
  return !hasConsent();
}

export function getConsentInfo() {
  if (typeof window === 'undefined') return null;
  try {
    const consent = localStorage.getItem(CONSENT_KEY);
    if (!consent) return null;
    return JSON.parse(consent);
  } catch (e) {
    return null;
  }
}

export function clearConsent() {
  if (typeof window === 'undefined') return;
  try {
    localStorage.removeItem(CONSENT_KEY);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.warn('Failed to clear cookie consent:', error);
  }
}


